var React = require('react');

function LocationSecondary (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b{fill:#1bfcbe}")),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1}),React.createElement("path",{"className":"b","d":"M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zM7 9a5 5 0 0110 0c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z","key":2}),React.createElement("circle",{"className":"b","cx":"2.5","cy":"2.5","r":"2.5","transform":"translate(9.5 6.5)","key":3})]);
}

LocationSecondary.defaultProps = {"width":"24","height":"24"};

module.exports = LocationSecondary;

LocationSecondary.default = LocationSecondary;
